var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-machine"},[(_vm.machine)?_c('machine-form',{attrs:{"machine":_vm.machine},on:{"submitted":_vm.back}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }